import { createReducer, on } from "@ngrx/store";

import { CURRENT_USER } from "../../_services/user.service";
import { ApiKeyActions } from ".";
import { ApiKey, NewApiKey } from "./api-key.models";

export interface ApiKeyState {
  apiKeys: ApiKey[] | null;
  loadApiKeysError: string | null;
  newApiKey: NewApiKey | null;
}

export const initialState: ApiKeyState = {
  apiKeys: null,
  loadApiKeysError: null,
  newApiKey: null,
};

export const apiKeyReducer = createReducer(
  initialState,

  on(ApiKeyActions.getApiKeys, state => ({
    ...state,
    loadApiKeysError: null,
  })),

  on(ApiKeyActions.getApiKeysSuccess, (state, { apiKeys }) => ({
    ...state,
    apiKeys,
  })),
  on(ApiKeyActions.apiKeysFailure, (state, { error }) => ({
    ...state,
    loadApiKeysError: error,
  })),

  on(ApiKeyActions.createApiKeySuccess, (state, { newApiKey }) => ({
    ...state,
    apiKeys: [
      ...state.apiKeys!,
      {
        id: newApiKey.id,
        hint: `${newApiKey.apiKey.substring(0, 4)}...${newApiKey.apiKey.substring(newApiKey.apiKey.length - 4, newApiKey.apiKey.length)}`,
        createdAt: new Date().toISOString(),
        createdBy: CURRENT_USER,
        expiresAt: null,
        isExpired: false,
        isEnabled: true,
      },
    ],
    newApiKey,
  })),

  on(ApiKeyActions.deleteApiKeySuccess, (state, { id }) => ({
    ...state,
    newApiKey: state.newApiKey?.id === id ? null : state.newApiKey,
    apiKeys: state.apiKeys?.filter(apiKey => apiKey.id !== id) ?? null,
  })),

  on(ApiKeyActions.toggleApiKeySuccess, (state, { id, isEnabled }) => ({
    ...state,
    apiKeys:
      state.apiKeys?.map(apiKey =>
        apiKey.id === id ? { ...apiKey, isEnabled } : apiKey
      ) || null,
  })),

  on(ApiKeyActions.clearCreatedApiKey, state => ({
    ...state,
    newApiKey: null,
  }))
);
